export default __webpack_public_path__ + "static/media/vitaminB12.c3577695.svg";